
import { defineComponent, ref, onMounted, onUnmounted } from "vue";

export default defineComponent({
  name: "BackToTopButton",
  props: {
    isInfoPanelOpen: { type: Boolean, default: false }
  },
  setup() {
    const isVisible = ref(false);

    const toggleVisibility = () => {
      isVisible.value = window.scrollY > 200;
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    onMounted(() => {
      window.addEventListener("scroll", toggleVisibility);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", toggleVisibility);
    });

    return { isVisible, scrollToTop };
  }
});
